
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/products",
      function () {
        return require("private-next-pages/en/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/products"])
      });
    }
  